// extracted by mini-css-extract-plugin
export var header = "_gi-0";